<div [formGroup]="filterForm" class="filter-container">
  <div class="chips-row"
    cdkDropList
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="drop($event)"
    aria-label="Seletor de campos">
    <nz-tag class="category-chip"
      *ngFor="let field of fields"
      nzMode="closeable"
      cdkDrag
      (dblclick)="onDoubleClick()"
      [ngStyle]="{'background-color': chipColorFn(field)}"
      (nzOnClose)="remove(field)">
      <div class="category-chip__text">{{field}}</div>
    </nz-tag>

    <input nz-input
      class="expression-input"
      placeholder="Expressão"
      #expressionInput
      formControlName="expressaoCtrl"
      (keydown.enter)="addExpression(expressionInput)">
  </div>

  <div class="twocolumns">
    <div class="id">
      <input nz-input type="text"
          placeholder="Selecionar uma coluna"
          aria-label="Coluna"
          formControlName="fieldsCtrl"
          [nzAutocomplete]="auto">
      <nz-autocomplete #auto="nzAutocomplete" (selectionChange)="selected($event?.nzValue ?? $event)">
        <nz-auto-option *ngFor="let field of filteredFields | async" [nzValue]="field.COLUMNNAME">
          {{field.COLUMNNAME}}
        </nz-auto-option>
      </nz-autocomplete>
    </div>
    <div class="andor">
      <input nz-input type="text"
        placeholder="Selecionar um operador"
        aria-label="Operador"
        formControlName="operatorCtrl"
        [nzAutocomplete]="autoOperator">
      <nz-autocomplete #autoOperator="nzAutocomplete" (selectionChange)="selectedOperation($event?.nzValue ?? $event)">
        <nz-auto-option *ngFor="let operator of operators" [nzValue]="operator.value">
          {{operator.name}}
        </nz-auto-option>
      </nz-autocomplete>
    </div>
    <div class="value">
      <input nz-input *ngIf="!checked" [type]="typeField"
        placeholder="Digitar o valor"
        aria-label="Valor"
        (input)="inputValue($event)"
        formControlName="valueCtrl">

      <input nz-input *ngIf="checked" type="text"
        placeholder="Nome do Parâmetro"
        aria-label="Nome Parâmetro"
        (input)="inputValue($event)"
        formControlName="valueNomeParCtrl">

      <input nz-input *ngIf="checked" type="text"
        placeholder="Descrição do Parâmetro"
        aria-label="Descrição Parâmetro"
        (input)="inputValue($event)"
        formControlName="valueDescParCtrl">

      <ng-container *ngIf="checked">
        <input nz-input type="text"
          placeholder="Tipo de Parâmetro"
          aria-label="Tipo Parâmetro"
          [nzAutocomplete]="autoTipoPar"
          formControlName="valueTipoParCtrl">
        <nz-autocomplete #autoTipoPar="nzAutocomplete" (selectionChange)="selectParTipo($event?.nzValue ?? $event)">
          <nz-auto-option *ngFor="let parametro of partipo" [nzValue]="parametro.value">
            {{parametro.name}}
          </nz-auto-option>
        </nz-autocomplete>
      </ng-container>

      <textarea nz-input *ngIf="checked && showTextBox"
        placeholder="Lista de Opções ( Formato Chave=Value )"
        aria-label="ListaOpcoes"
        (input)="inputValue($event)"
        formControlName="valueListOpCtrl"
        [nzAutosize]="{ minRows: 2, maxRows: 5 }"></textarea>

      <label nz-checkbox [formControl]="variable" (ngModelChange)="onCheckClick()" [nzDisabled]="disableVariable">Variável</label>
    </div>

    <div class="andor">
      <input nz-input type="text"
        placeholder="Selecionar um tipo"
        aria-label="E/Ou"
        formControlName="andOrCtrl"
        [nzAutocomplete]="autoAndOr">
      <nz-autocomplete #autoAndOr="nzAutocomplete" (selectionChange)="selectAndOr($event?.nzValue ?? $event)">
        <nz-auto-option *ngFor="let andOr of andOrList" [nzValue]="andOr.value">
          {{andOr.name}}
        </nz-auto-option>
      </nz-autocomplete>
    </div>


    <button class="button" #chk nz-button nzType="primary" nzShape="circle" nz-tooltip="Adicionar expressão" [disabled]="btnDisable" (click)="add()">
      <nz-icon nzType="check"></nz-icon>
    </button>

  </div>
</div>
